import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import { Label } from "reactstrap";
import { withTranslation } from "react-i18next";

import {  apiQueryBuilderApiErrorAction } from "../../../store/actions";

import * as url from "../../../helpers/url_helper/url_helper"
import { get as getRuleValuesFromApi } from "../../../helpers/api_helper/ApiHelpers/apiHelpers";
import { convertStringValuesToArray } from "../../../common/Library/commonFunctions";

const initialQuery = {
  rules: [],
};

let profileFilterGlobalLists = [];

const tdStyle = {verticalAlign:"middle"};

class RavenQueryViewer extends Component {
  _isMounted = false;
  _isLoadigContinue = Number.MAX_VALUE;
  _isFetching = false;
  _profileFilterList = [];

  constructor(props) {
    super(props);
    this.state = {
      rules: []
    };
  }

  //#region Base Operations
  componentDidMount() {
    this._isMounted = true;
    this.props.apiError("");

    if(this.props.privateProfile)
      return;

    const list = this.getFilterList()
    if(list)
      this._profileFilterList = list;
    else
    {
      setTimeout( () => {
      getRuleValuesFromApi(url.QUERY_BUILDER_PROFILEFILTERS_GET+"?profileGroupGuid="+ this.props.profileGroupGuid)
      .then(values => {
        if(this._isMounted)
        {
          this.addToFilterList(values);
          this._profileFilterList = values;
          this.getDynamicFieldValues(this._profileFilterList);
        }
      })
      .catch(error => {
        console.error(error.message)
      });
    }, 500);
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
      if(this._profileFilterList.length !== 0 && this._isMounted && !this._isFetching && !this.props.privateProfile)
      {
        this.getDynamicFieldValues(this._profileFilterList);
      }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  //#endregion

  getFilterList()
  {
    if(!profileFilterGlobalLists || profileFilterGlobalLists.length === 0)
      return undefined;

    return profileFilterGlobalLists.find(i => i?.pprofileGroupGuid === this.props.profileGroupGuid)?.profileFilterList
  }

  addToFilterList(list)
  {
    const exists = profileFilterGlobalLists.find(i => i?.pprofileGroupGuid === this.props.profileGroupGuid);

    if(exists === undefined)
    {
      profileFilterGlobalLists = profileFilterGlobalLists.concat([{pprofileGroupGuid:this.props.profileGroupGuid, profileFilterList: list}]);
    }
  }

  getDynamicFieldValues(profileFilterList) {
    if(this.props.privateProfile)
      return;

    let query = initialQuery;
    this._isFetching = true;

    if(this.props.initializeQuery?.length)
    {
      query = JSON.parse(this.props.initializeQuery);
    }
    
    if (profileFilterList?.length) {
      const ruleValuesArr = query.rules.map(item => ({
        ruleValues: profileFilterList.find(
          i => (i.filterKeyword === item.field)
        ),
        field: item.field,
        operator: item.operator,
        value: item.value
      }));

      if(this._isLoadigContinue === Number.MAX_VALUE)
        this._isLoadigContinue = 0;

      const rulesArr = ruleValuesArr.map(item => ({
        field: item.field,
        fieldName: item.ruleValues ? this.props.t(item.ruleValues.filterKeyword) : item.field,
        operator: this.getOperatorDesc(item.ruleValues, item.operator) || item.operator,
        value: item.value,
        valueName: item.ruleValues ? this.getDynamicValueName(
          item.ruleValues.filterKeyword,
          item.value,
          item.ruleValues.apiConfigKey,
          item.ruleValues.apiMethodName,
          item.ruleValues.userInterfaceData
        ) : item.value,
      }));

      this.setState({
        rules: rulesArr.map(item => ({
          field: item.fieldName,
          operator: item.operator,
          value: item.valueName,
          filterKeyword: item.field
        })),
      });
    }
    else
      this.setState({ rules: query.rules });
  }

  getOperatorDesc(rule, operatorValue) {
    let operatorItem;

    if(rule?.profileFilterFieldType?.profileFilterOperatorDefList)
      operatorItem = rule.profileFilterFieldType.profileFilterOperatorDefList.find(o => o.operator === operatorValue);

    if(operatorItem)
      return operatorItem.description
    
    return operatorValue
  }

  getDynamicValueName(filterKeyword, valueKey, apiConfigKey, apiMethodUrl, userInterfaceData) {
    if(valueKey === "" || valueKey === "[]")
      return "! Empty !";

    if (apiConfigKey && apiConfigKey !== '') {
      this._isLoadigContinue = this._isLoadigContinue + 1;

      getRuleValuesFromApi(apiMethodUrl)
      .then(values => {
        if(this._isMounted)
          this.setDynamicValueName(values, filterKeyword, userInterfaceData, valueKey);
      })
      .catch(error => {
        console.error(error.message)
      });

      return this.props.t("loading");
    }
    else
      return valueKey;
  }

  setDynamicValueName = (apiValues, filterKeyword, userInterfaceData, valueKey) => {
    const { rules } = this.state;

    const userInterfaceValues = JSON.parse(userInterfaceData);

    const valueName = this.parseValueName(apiValues, valueKey, userInterfaceValues);

    if (rules?.length) {
      rules.forEach(item => {
        if (item && item.filterKeyword === filterKeyword) item.value = !isEmpty(valueName) ? valueName : valueKey;
      });
      this._isLoadigContinue = this._isLoadigContinue - 1;
      this.setState({ rules: rules });
    }
  };

  parseValueName(apiValues, valueKey, userInterfaceValues)
  {
    if(valueKey.indexOf("[") !== -1)
    {
      const values = convertStringValuesToArray(valueKey);

      const names = apiValues.filter(i => values.indexOf(i.guid.toString()) > -1).map(item => ({
        value: this.getUserIterfaceData(item, userInterfaceValues)
      }));

      return names;
    }
    else
    {
      const value = apiValues.find(i => i.guid === valueKey);
      
      if(value)
        return this.getUserIterfaceData(value, userInterfaceValues);
    
      return valueKey;
    }
  }

  getUserIterfaceData(item, userInterfaceValues) {
    let userData = "";
    let sep = "";

    if (userInterfaceValues?.fields) {
      if (userInterfaceValues.fields.length >= 2) sep = userInterfaceValues.sep;

      userInterfaceValues.fields.forEach((field, index, array) => {
        userData = userData + item[field] + (index + 1 === array.length ? "" : sep);
      });

      return userData;
    }
    else
      return "Invalid definition";
  }

  getContent(rules)
  {
    if(rules?.length)
    {
      return (
        rules.map((item, index, arr) => (
          [
            <tr key={item.field + index.toString()} >
                <td style={tdStyle}><Label className="query-viewer-field">{item.field}</Label></td>
                <td style={tdStyle}><Label className="query-viewer-operator">{item.operator}</Label></td>
                <td style={tdStyle}>
                <div className="query-viewer-valuecontainer">
                {
                  Array.isArray(item.value) ?
                  item.value.map((item2, index2, arr2) => (
                    <div key={item.field + item2.value + index.toString() + index2.toString()}>
                    <Label className="query-viewer-value">{item2.value}</Label>
                    {index2 !== arr2.length - 1 && <label style={{width:"5px"}}></label>}
                    </div>
                  ))
                  :
                  <Label  key={item.field + index.toString()} className="query-viewer-value">{item.value}</Label>
                }
                </div>
                </td>
            </tr>,
            
              index !== arr.length - 1 &&
            <tr key={item.field + index.toString() + "combinator"} >
              <td colSpan={3} className="query-viewer-combinator-div">
              
                    <button className="query-viewer-combinator">
                      {"AND"}
                    </button>
            </td>
            </tr>
          
          ]
        ))
      );
    }
    else
    return(
      <tr>
        <td>{"[ ]"}</td>
      </tr>
    )
  }

  prepareRenderWithoutMountForAgGrid()
  {
    if(this._isMounted || this._isFetching || isEmpty(profileFilterGlobalLists))
      return;

    const list = this.getFilterList();
    if(list)
    {
      this._profileFilterList = list;
      this.getDynamicFieldValues(list);
    }
  }

  render() {
    const rules = this.state.rules;

    if(this.props.privateProfile)
      return(
        <div className="query-viewer-div  query-viewer-value">
        {this.props.t("AccountProfile")}
        </div>
      );

    this.prepareRenderWithoutMountForAgGrid();

    if (isEmpty(this._profileFilterList) || this._isLoadigContinue > 0) {
      return this.props.t("loading");;
    }

    return (
      <div className="query-viewer-div">
        <table>
        <tbody>
        {
          this.getContent(rules)
        }
        </tbody>
        </table>
      </div>
    );
  }
}

RavenQueryViewer.propTypes = {
  profileGroupGuid: PropTypes.number.isRequired,
  initializeQuery: PropTypes.string.isRequired,
  privateProfile: PropTypes.bool,
  // profileFilterList: PropTypes.array,
  // onGetProfileFilterList: PropTypes.func,
  apiError: PropTypes.any,
  error: PropTypes.any,
  t: PropTypes.any,
};

const mapStateToProps = ({ queryBuilderReducer }) => ({
  //profileFilterList: queryBuilderReducer.profileFilterList,
  error: queryBuilderReducer.error,
});

const mapDispatchToProps = dispatch => ({
  //onGetProfileFilterList: guid => dispatch(getQueryBuilderProfileFilterListAction(guid)),
  apiError: error => dispatch(apiQueryBuilderApiErrorAction(error)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(RavenQueryViewer));
